import { combineReducers } from 'redux';

import customizationReducer from './customizationReducer';
import filtersReducer from './filtersReducer';
import terminals from './terminalsSlice';

const reducer = combineReducers({
  customization: customizationReducer,
  filters: filtersReducer,
  terminals
});

export default reducer;
